import React, { Component } from 'react'
import PropTypes from 'prop-types'
import translate from 'react-i18next/dist/commonjs/translate'
import CloseIconSVG from 'component/svgComponents/close'

const MODAL_SIZES = ['sm', 'md', 'lg']

class Modal extends Component {
  static propTypes = {
    noCloseOnConfirm: PropTypes.bool,

    buttonClass: PropTypes.string,

    /* Title of the modal */
    title: PropTypes.string,

    /* Determines the modal size */
    size: PropTypes.oneOf(MODAL_SIZES),

    /* Callback that will be triggered when the modal closes  */
    onCloseModal: PropTypes.func,

    /* Callback that will be triggered when the modal open  */
    onOpenModal: PropTypes.func,

    /* Callback that will be triggered when the modal is confirmed */
    onConfirm: PropTypes.func,

    /* Props children */
    children: PropTypes.object,

    contentBeforeChildren: PropTypes.object,

    /* Allow to render a child with close/confirm props */
    renderChildrenWithProps: PropTypes.func,

    /* Modal open button text */
    buttonText: PropTypes.string,

    /* Modal confirm button text */
    confirmButtonText: PropTypes.string || PropTypes.array,

    /* Confirmation types (danger or success) */
    confirmType: PropTypes.string,

    /* Modal confirm button disabled */
    isConfirmButtonDisabled: PropTypes.bool,

    /* Function for rendering a custom button */
    renderButton: PropTypes.func,

    /* String for btn cancel text */
    cancelButtonText: PropTypes.string,

    /* Bool that tells the modal if the header should be shown (default true) */
    showHeader: PropTypes.bool,

    /* Bool that tells the modal if the footer should be shown (default true) */
    showFooter: PropTypes.bool,

    /* Bool that tells the modal if it should be fixed open (default false) */
    isOpen: PropTypes.bool,

    /* Bool that tells the modal if it should disable the max-height (usefull for modals with selects) */
    disableMaxHeight: PropTypes.bool,

    /* Translation method */
    translate: PropTypes.func,

    /* If "visible" than the modal will not scroll the content */
    overflow: PropTypes.string,

    /* Bool that tells the modal if the content should be centered (default true) */
    center: PropTypes.bool,

    /* Disable bg click close */
    disabledBgClickClosing: PropTypes.bool,

    /* Hide cancel button */
    hideCancelButton: PropTypes.bool,

    /* Custom classname to modal */
    className: PropTypes.string,

    /* Allow to use the external isOpen */
    useControlledState: PropTypes.bool,
  }

  static defaultProps = {
    size: 'md',
    confirmButtonText: 'Confirmar',
    isConfirmButtonDisabled: false,
    showHeader: true,
    showFooter: true,
    disableMaxHeight: false,
    className: '',
  }

  state = {
    /* Stores the information of wheter the modal is or not shown */
    isOpen: false,
    isAtTop: true,
    isAtBottom: false,
    hasScroll: false,
  }

  contentRef = React.createRef()

  componentDidMount() {
    const { isOpen } = this.props
    if (isOpen) {
      this.setState({ isOpen })
    }
  }

  
  checkOpenState() {
    const { isOpen: stateOpen } = this.state
    const { isOpen, useControlledState = false } = this.props

    if (useControlledState && isOpen !== stateOpen) {
      this.setState({ isOpen })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkOpenState()

    // Quando o modal acabou de abrir
    if (!prevState.isOpen && this.state.isOpen) {
      setTimeout(() => {
        if (this.contentRef.current) {
          this.contentRef.current.addEventListener('scroll', this.handleScroll)
          this.handleScroll()
        }
      }, 0)
    }

    // Quando o modal foi fechado
    if (prevState.isOpen && !this.state.isOpen) {
      if (this.contentRef.current) {
        this.contentRef.current.removeEventListener('scroll', this.handleScroll)
      }
    }
  }

  componentWillUnmount() {
    if (this.contentRef.current) {
      this.contentRef.current.removeEventListener('scroll', this.handleScroll)
    }
  }

  handleScroll = () => {
    const el = this.contentRef.current
    if (!el) return

    const hasScroll = el.scrollHeight > el.clientHeight
    let isAtTop = true
    let isAtBottom = true

    if (hasScroll) {
      isAtTop = el.scrollTop === 0
      isAtBottom = el.scrollHeight - el.scrollTop === el.clientHeight
    }

    if (
      isAtTop !== this.state.isAtTop ||
      isAtBottom !== this.state.isAtBottom ||
      hasScroll !== this.state.hasScroll
    ) {
      this.setState({ isAtTop, isAtBottom, hasScroll })
    }
}

  onConfirm = () => {
    const { onConfirm = () => {}, noCloseOnConfirm } = this.props
    if (noCloseOnConfirm) onConfirm()
    else this.setState({ isOpen: false }, onConfirm)
  }

  onClose = () => {
    const { onCloseModal = () => {}, noCloseOnConfirm } = this.props
    if (noCloseOnConfirm) onCloseModal()
    else this.setState({ isOpen: false }, onCloseModal)
  }

  openModal = () => {
    const { onOpenModal = () => {} } = this.props
    this.setState({ isOpen: true }, onOpenModal)
    window.scrollTo(0, 0)
  }

  renderDefaultButton = () => {
    const { buttonText, onClick } = this.getButtonProps()
    return (
      <button className='open-modal-button' onClick={onClick}>
        {buttonText}
      </button>
    )
  }

  getButtonProps = () => {
    const { buttonText } = this.props
    return { onClick: this.openModal, buttonText }
  }

  render() {
    const {
      buttonClass,
      center,
      overflow,
      title,
      size,
      confirmButtonText,
      renderButton,
      children,
      renderChildrenWithProps,
      isConfirmButtonDisabled,
      showHeader,
      showFooter,
      confirmType,
      cancelButtonText,
      disableMaxHeight,
      translate,
      className,
      buttonText,
      disabledBgClickClosing,
      hideCancelButton,
      contentBeforeChildren,
    } = this.props

    const { isOpen } = this.state

    return (
      <>
        {(!renderButton && !buttonText) ||
          (renderButton
            ? renderButton(this.getButtonProps())
            : this.renderDefaultButton(this.getButtonProps()))}
        {isOpen && (
          <>
            <div className={`bg ${disableMaxHeight ? 'no-max-height' : ''}`}>
              <div
                className='bg-clickable'
                onClick={() => !disabledBgClickClosing && this.onClose()}
              />
              <div
                className={`custom-modal ${size} ${center && 'center'} ${
                  className || ''
                }`}
              >
                {showHeader && (
                  <div className={`custom-modal-title ${this.state.hasScroll && this.state.isAtBottom ? 'scrolled' : ''}`}>
                    <h3>{title}</h3>
                    <i className='glyph glyph-times' />
                    <span
                      className='custom-modal-close-icon'
                      onClick={this.onClose}
                    >
                      <CloseIconSVG />
                    </span>
                  </div>
                )}
                {contentBeforeChildren && <div>{contentBeforeChildren}</div>}
                <div
                  ref={this.contentRef}
                  className={`custom-modal-content ${
                    overflow === 'visible'
                      ? 'overflow-visible'
                      : 'overflow-auto'
                  }`}
                >
                  {renderChildrenWithProps
                    ? renderChildrenWithProps({
                        onClose: this.onClose,
                        onConfirm: this.onConfirm,
                      })
                    : children}
                </div>
                {showFooter && (
                  <div className={`custom-modal-footer ${this.state.hasScroll && this.state.isAtTop ? 'scrolled' : ''}`}>
                    {!hideCancelButton && (
                      <button
                        className={`custom-modal-close-button ${buttonClass}`}
                        onClick={this.onClose}
                      >
                        {cancelButtonText || translate('cancel_button')}
                      </button>
                    )}
                    <button
                      disabled={isConfirmButtonDisabled}
                      className={
                        confirmType === 'danger'
                          ? 'btn btn-danger'
                          : `custom-modal-confirm-button ${buttonClass}`
                      }
                      onClick={this.onConfirm}
                    >
                      {confirmButtonText}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </>
    )
  }
}

export default translate(null, { wait: true, translateFuncName: 'translate' })(
  Modal
)
